import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { TokenAnnotator } from "react-text-annotate";
import { Span } from 'react-text-annotate/lib/span';
interface Label {
    start: number;
    end: number;
    label: string;
    background: string;
    tag: string;
    color: string;
    tokens: string[];
}

interface LabelActionProps {
    actionValue: {
        config_details: any;
        labels: Label[];
    }[];
    result: any
}
export default function LabelAction({ actionValue, result }: LabelActionProps) {
    console.log({ result })
    interface AnnotatedSpan extends Span {
        tokens: any;
        tag: string;
        color?: string;
        content?: string;
    }
    const [value, setValue] = useState<AnnotatedSpan[]>([]);
    const [tag, setTag] = useState<string>('');
    const [tagColors, setTagColors] = useState<{ [key: string]: string }>({});


    if (actionValue?.length === 0) {
        return <Typography>No label available.</Typography>;
    }

    const processContentWithLineBreaks = (content: string | null | undefined): string[] => {
  if (!content) return [];
  
  // First, convert escape sequences
  const unescaped = content
    .replace(/\\n/g, '\n')
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\t/g, '\t')
    .replace(/\\r/g, '\r')
    .replace(/\\\\/g, '\\');
  
  // Split by lines first, then by spaces within each line
  const lines = unescaped.split('\n');
  const tokens: string[] = [];
  
  lines.forEach((line: string, lineIndex: number) => {
    if (lineIndex > 0) {
      tokens.push('\n'); // Add line break token between lines
    }
    // Split line by spaces and add non-empty tokens
    const lineTokens = line.split(' ').filter(token => token.length > 0);
    tokens.push(...lineTokens);
  });
  
  return tokens;
};

    

    return (
        <>
            {actionValue.map((value, valueIndex) => {
                const colorsMap: { [key: string]: string } = {};
                if (value?.config_details?.value) {
                    value.config_details?.value?.value?.forEach((tagItem: { value: string | number; color: string; }) => {
                        colorsMap[tagItem.value] = tagItem.color;
                    });
                }
                return (
                    <>
                        <div className="flex items-center mb-4" key={valueIndex}>
                            <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
                                                    {value.config_details?.value?.label || 'Labelled Text'} :
                                                </Typography>
                            <select
                                className="p-2 rounded border border-[#ccc]"
                                //onChange={handleTagChange}
                                value={tag}
                            >
                                {value?.config_details?.value?.value?.map((tag: any) => (
                                    <option key={tag.value} value={tag.value}>
                                        {tag.name}
                                    </option>
                                ))}
                            </select>
                            <div className="flex items-center ml-4 gap-2 text-sm">
                                {value?.config_details?.value?.value?.map((t: any) => {
                                    const count = value.labels.map((span: any) => ({
                                        ...span,
                                        tokens: span.tokens || span.text?.split(' ') || [],
                                        color: colorsMap[span.tag] || '#ccc',
                                    })).filter((v: any) => v.tag === t.value).length;
                                    return (
                                        <span
                                            key={t.value}
                                            className="px-2 py-1 rounded text-white text-xs"
                                            style={{ backgroundColor: t.color }}
                                        >
                                            {t.name}: {count}
                                        </span>
                                    );
                                })}
                            </div>
                        </div>

                        <TokenAnnotator
                            className="leading-7 whitespace-pre-wrap"
                            tokens={processContentWithLineBreaks(value?.config_details?.default_value) || ''}
                            onChange={() => { }}
                            value={value.labels.map((span: any) => ({
                                ...span,
                                tokens: span.tokens || span.text?.split(' ') || [],
                                color: colorsMap[span.tag] || '#ccc',
                            }))}
                            getSpan={(span) => ({
                                ...span,
                                tag: tag,
                                color: tagColors[tag],
                                content: span.tokens.join(' ')
                            })}
                            renderMark={(props) => (
                                <mark
                                    key={props.key}
                                    onClick={() =>
                                        props.onClick({
                                            start: props.start,
                                            end: props.end,
                                            content: props.content,
                                            tag: props.tag,
                                            color: props.color,
                                        })
                                    }
                                    className="px-1 rounded cursor-pointer"
                                    style={{ background: props.color }}
                                >
                                    {props.content}{' '}
                                    <span className="bg-white text-xs rounded mx-1 px-1 text-gray-800">
                                        {props.tag}
                                    </span>
                                </mark>
                            )}
                        />
                    </>
                )
            })}
        </>
    );
}